import React, { FC } from 'react';
import styles from './index.module.css';

interface EddLayoutProps {
    left: React.ReactNode;
}

const EddLayout: FC<EddLayoutProps> = ({ left }) => (
  <div className={styles.eddContent}>
    <div className={styles.eddContentLeft}>{left}</div>
    <div className={styles.eddContentRight}>
      <div className={styles.rightBackground} />
    </div>
  </div>
);

export { EddLayout };
